import { useCallback, useState } from 'react';

import { SyncCallback } from '../../../../../../types/types';
import { JUST_LOGGED_IN_TIMESTAMP_KEY, JUST_LOGGED_IN_TIMEOUT_MS } from '../../../../Common/constants';

export interface OTPState {
    readonly showOTP: boolean;
    readonly openOTP: SyncCallback;
    readonly closeOTP: SyncCallback;
}

/**
 * Check if user just completed OAuth login to prevent showing OTP modal unnecessarily
 */
const checkIfJustLoggedIn = (): boolean => {
    const justLoggedInTimestamp = sessionStorage.getItem(JUST_LOGGED_IN_TIMESTAMP_KEY);
    return justLoggedInTimestamp !== null
        && (Date.now() - parseInt(justLoggedInTimestamp, 10)) < JUST_LOGGED_IN_TIMEOUT_MS;
};

const useOTPState = (): OTPState => {
    // Initialize OTP state based on login status to prevent flash
    const [showOTP, setShowOTP] = useState<boolean>(() => !checkIfJustLoggedIn());

    const openOTP = (): void => {
        setShowOTP(true);
    };

    const closeOTP = useCallback((): void => {
        setShowOTP(false);
    }, []);

    return {
        showOTP,
        openOTP,
        closeOTP,
    };
};

export default useOTPState;
